import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ActionPayload {
  visible?: boolean;
  data?: string;
  recordData: any;
  startTime?: string;
  endTime?: string;
}

const initialState: ActionPayload = {
  data: "",
  visible: false,
  recordData: null,
  startTime: "",
  endTime: "",
};

const diagnosticCenterSlice = createSlice({
  name: "diagnosticCenter",
  initialState,
  reducers: {
    setDiagnosticCenterValue: (state, action: PayloadAction<any>) => {
      state.visible = action.payload.visible;
      state.data = action.payload.data;
      state.recordData = action.payload.recordData;
      state.startTime = action.payload.startTime;
      state.endTime = action.payload.endTime;
    },
  },
});

export const { setDiagnosticCenterValue } = diagnosticCenterSlice.actions;
export default diagnosticCenterSlice.reducer;
